import cx from 'classnames'
import Styles from './Section.module.scss'
import { Button } from 'components/Button/Button'
import { ReactComponent as ResolvedIcon } from 'assets/icons/check16.svg'
import { observer } from 'mobx-react-lite'
import { useDocStore } from 'stores/DocStore'
import { baseFilters, resolvedFilter } from 'stores/CollabItemsFilters'
import { lowerCase } from 'lodash'

interface Props {
  sectionName: string
  sectionKey: string
  className?: string
}

export const EmptyState = observer(({ sectionName, sectionKey, className }: Props) => {
  const docStore = useDocStore()
  const filter = baseFilters.find((filter) => filter.key === sectionKey)
  const items = filter ? docStore.collabItems.filter((item) => filter.fn(item)) : []

  const handleClick = () => {
    docStore.filters.activate('resolved')
  }

  if (items.length === 0) {
    return <div className={cx(Styles.emptySectionLabel, className)}>No {lowerCase(sectionName)} on this doc yet</div>
  }

  const unresolvedItems = items.filter((item) => !resolvedFilter.fn(item))
  if (unresolvedItems.length > 0 || docStore.filters.activeKeys.has('resolved')) return null

  return (
    <Button
      className={cx(Styles.emptySectionButton, className)}
      variant="tertiary"
      frontIcon={ResolvedIcon}
      onPress={handleClick}
    >
      Show resolved {lowerCase(sectionName)}
    </Button>
  )
})
